<template>
  <el-input
      class="phone-input"
      v-model="phone"
      :placeholder="placeholder"
      @change="handlePhoneChange"
      @input="handlePhoneChange"
      :clearable="clearable"
  >
    <el-select
        v-model="areaCodeSelected"
        slot="prepend"
        :placeholder="$t('shipping_address.area_code')"
        @change="handlePhoneChange"
    >
      <el-option :label="item.name" :value="item.code" v-for="item in areaCodes" :key="item.code"></el-option>
    </el-select>

    <template v-if="$slots.append" slot="append">
      <slot name="append"></slot>
    </template>
  </el-input>
</template>

<script>
  import _ from 'lodash';
  import emitter from 'element-ui/src/mixins/emitter';
  import Migrating from 'element-ui/src/mixins/migrating';
  import { parsePhoneNumberFromString } from 'libphonenumber-js';

  export default {
    name: 'PhoneInput',
    componentName: 'PhoneInput',
    mixins: [emitter, Migrating],

    mounted() {
      if (!this.areaCodeSelected) {
        this.areaCodeSelected = this.defaultAreaCode;
      }
    },
    props: {
      value: [String, Number],
      placeholder: {
        type: String,
        default: '',
      },
      defaultAreaCode: {
        type: String,
        default: '+852',
      },
      clearable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        phone: '',
        areaCodeSelected: '',
        countryCode: '',
        areaCodes: [
          {
            name: `${this.$t('area.HongKong')} +852`,
            code: '+852',
            countryCode: 'HK',
          },
          {
            name: `${this.$t('area.China')} +86`,
            code: '+86',
            countryCode: 'CN',
          },
          {
            name: `${this.$t('area.Macau')} +853`,
            code: '+853',
            countryCode: 'MO',
          },
          {
            name: `${this.$t('area.TaiWan')} +886`,
            code: '+886',
            countryCode: 'TW',
          },
          {
            name: `${this.$t('area.US')} +1`,
            code: '+1',
            countryCode: 'US',
          },
          {
            name: `${this.$t('area.France')} +33`,
            code: '+33',
            countryCode: 'FR',
          },
          {
            name: `${this.$t('area.UK')} +44`,
            code: '+44',
            countryCode: 'UK',
          },
          {
            name: `${this.$t('area.Germany')} +49`,
            code: '+49',
            countryCode: 'DE',
          },
          {
            name: `${this.$t('area.Malaysia')} +60`,
            code: '+60',
            countryCode: 'MY',
          },
          {
            name: `${this.$t('area.Australia')} +61`,
            code: '+61',
            countryCode: 'AU',
          },
          {
            name: `${this.$t('area.NewZealand')} +64`,
            code: '+64',
            countryCode: 'NZ',
          },
          {
            name: `${this.$t('area.Singapore')} +65`,
            code: '+65',
            countryCode: 'SG',
          },
          {
            name: `${this.$t('area.Thailand')} +66`,
            code: '+66',
            countryCode: 'TH',
          },
          {
            name: `${this.$t('area.Japan')} +81`,
            code: '+81',
            countryCode: 'JP',
          },
          {
            name: `${this.$t('area.Korea')} +82`,
            code: '+82',
            countryCode: 'KR',
          },
          {
            name: `${this.$t('area.VietNam')} +84`,
            code: '+84',
            countryCode: 'VN',
          },
          {
            name: `${this.$t('area.Cambodia')} +855`,
            code: '+855',
            countryCode: 'KH',
          },
        ],
      };
    },
    computed: {
      phoneField: {
        get() {
          if (this.phone) {
            return this.phone;
          }
          const { areaCode, phone } = this.explode(this.value);
          console.log(this.value);
          if (areaCode) {
            /* eslint-disable */
            this.areaCodeSelected = areaCode;
            this.phone = phon;
          }
          return phone;
        },
        set(val) {
          const { areaCode, phone } = this.explode(val);
          if (areaCode) {
            this.areaCodeSelected = areaCode;
          }
          this.phone = phone;
          this.handlePhoneChange();
        },
      },
    },
    methods: {
      getCountryCode() {
        return this.countryCode;
      },
      getAreaCode() {
        return this.areaCodeSelected;
      },
      setValue(val) {
        const { areaCode, phone } = this.explode(val);
        if (areaCode) {
          this.areaCodeSelected = areaCode;
        }
        this.phone = phone;
      },
      handlePhoneChange() {
        if (this.phone) {
          if (this.areaCodeSelected) {
            this.countryCode = _.find(this.areaCodes, item => item.code === this.areaCodeSelected).countryCode;

            if (this.phone.length > 3) {
              const phoneNumber = parsePhoneNumberFromString(this.phone, this.countryCode);
              this.$emit('change', phoneNumber);
            } else {
              this.$emit('change', null);
            }

            this.$emit('input', `${this.areaCodeSelected} ${this.phone}`.trim());
          } else {
            this.$emit('input', this.phone.trim());
          }
        } else {
          this.$emit('input', '');
        }
      },
      explode(val) {
        let areaCode = '';
        let phone = '';
        this.phone = '';
        let hasAreaCode = false;
        if (val) {
          // eslint-disable-next-line
          for (const { code } of this.areaCodes) {
            if (val.startsWith(code)) {
              areaCode = code;
              phone = val.substring(code.length).trim();
              hasAreaCode = true;
              break;
            }
          }
          if (!hasAreaCode) {
            phone = val;
          }
        }
        return {
          areaCode, phone,
        };
      },
    },
  };
</script>

<style lang="scss">
  .phone-input {
    .el-input-group__prepend {
      min-width: 8.5rem;
    }
  }
</style>
